// src/hooks/useTurnstile.js

import React from 'react';

export function useTurnstile() {
    const [turnstileToken, setTurnstileToken] = React.useState('');
    const turnstileRef = React.useRef(null);
    const widgetIdRef = React.useRef(null);

    const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
    const isCaptchaConfigured = Boolean(siteKey);

    React.useEffect(() => {
        if (!siteKey) return;

        function renderTurnstile() {
            if (!window.turnstile || !turnstileRef.current || widgetIdRef.current !== null) return;

            widgetIdRef.current = window.turnstile.render(turnstileRef.current, {
                sitekey: siteKey,
                callback: (token) => setTurnstileToken(token),
                'expired-callback': () => setTurnstileToken(''),
                'error-callback': () => setTurnstileToken('')
            });
        }

        if (window.turnstile) {
            renderTurnstile();
            return;
        }

        window.__onTurnstileLoad = renderTurnstile;

        const scriptId = 'cf-turnstile-script';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=__onTurnstileLoad';
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
        }

        return () => {
            if (window.turnstile && widgetIdRef.current !== null) {
                try { window.turnstile.remove(widgetIdRef.current); } catch (e) {}
                widgetIdRef.current = null;
            }
        };
    }, [siteKey]);

    function resetTurnstile() {
        if (window.turnstile && widgetIdRef.current !== null) {
            window.turnstile.reset(widgetIdRef.current);
            setTurnstileToken('');
        }
    }

    return { turnstileToken, turnstileRef, isCaptchaConfigured, resetTurnstile };
}